// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import Alert from "@mui/material/Alert";
// import AlertTitle from "@mui/material/AlertTitle";
// import {
//   Group,
//   Person,
//   Engineering,
//   SmartToy,
//   Email,
//   Phone,
//   CorporateFare,
//   EmojiEvents
// } from "@mui/icons-material";

// const MyTeamDetails = () => {
//   const { team_name } = useParams();
//   const [team, setTeam] = useState(null);
//   const [error, setError] = useState(null);
//   const token = localStorage.getItem("access_token");

//   useEffect(() => {
//     if (!token) {
//       setError("You are not authorized. Please log in.");
//       return;
//     }

//     const fetchTeamDetails = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}/team/user/${team_name}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         setTeam(response.data);
//       } catch (err) {
//         setError("Failed to fetch team details. Please try again.");
//       }
//     };

//     fetchTeamDetails();
//   }, [team_name, token]);

//   if (error) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <Alert severity="error">
//           <AlertTitle>Error</AlertTitle>
//           {error}
//         </Alert>
//       </div>
//     );
//   }

//   if (!team) {
//     return <div className="flex justify-center items-center h-screen text-xl font-semibold">Loading...</div>;
//   }

//   return (
//     <div className="max-w-4xl mx-auto p-6 bg-white shadow-xl rounded-2xl mt-10 mb-10 transition-all hover:shadow-2xl">
//       {/* Header Section */}
//       <div className="bg-gradient-to-r from-cyan-600 to-blue-500 text-white p-8 rounded-2xl text-center shadow-md">
//         <h2 className="text-4xl font-bold mb-2 drop-shadow-md">{team.name}</h2>
//         <div className="flex items-center justify-center gap-2">
//           <EmojiEvents className="text-yellow-300" />
//           <p className="text-xl font-medium">{team.competition_event}</p>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="space-y-6 mt-8">
//         {/* Key Details Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//           <div className="bg-white p-4 rounded-xl border border-gray-200 flex items-center gap-4 hover:bg-gray-50 transition-colors">
//             <div className="bg-cyan-100 p-3 rounded-lg text-cyan-600">
//               <SmartToy className="!text-2xl" />
//             </div>
//             <div>
//               <p className="text-sm text-gray-500">Robot Name</p>
//               <p className="font-medium text-gray-800">{team.robot_name || "TBA"}</p>
//             </div>
//           </div>

//           <div className="bg-white p-4 rounded-xl border border-gray-200 flex items-center gap-4 hover:bg-gray-50 transition-colors">
//             <div className="bg-cyan-100 p-3 rounded-lg text-cyan-600">
//               <CorporateFare className="!text-2xl" />
//             </div>
//             <div>
//               <p className="text-sm text-gray-500">Organization</p>
//               <p className="font-medium text-gray-800">
//                 {team.organization?.name ? `${team.organization.name} (${team.organization.type})` : "N/A"}
//               </p>
//             </div>
//           </div>

//           <div className="bg-white p-4 rounded-xl border border-gray-200 flex items-center gap-4 hover:bg-gray-50 transition-colors">
//             <div className="bg-cyan-100 p-3 rounded-lg text-cyan-600">
//               <Engineering className="!text-2xl" />
//             </div>
//             <div>
//               <p className="text-sm text-gray-500">Team Type</p>
//               <p className="font-medium text-gray-800">{team.type || "N/A"}</p>
//             </div>
//           </div>
//         </div>

//         {/* Team Leader Card */}
//         <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
//           <h3 className="text-xl font-semibold mb-4 flex items-center gap-2 text-cyan-700">
//             <Person className="!text-2xl" /> Team Leader
//           </h3>
//           <div className="space-y-3 pl-8">
//             <div className="flex items-center gap-3 text-gray-700">
//               <span className="text-gray-500"><Person /></span>
//               <span>{team.team_leader_name || "Not provided"}</span>
//             </div>
//             <div className="flex items-center gap-3 text-gray-700">
//               <span className="text-gray-500"><Email /></span>
//               <span>{team.team_leader_email || "Not provided"}</span>
//             </div>
//             <div className="flex items-center gap-3 text-gray-700">
//               <span className="text-gray-500"><Phone /></span>
//               <span>{team.team_leader_phone_number || "Not provided"}</span>
//             </div>
//           </div>
//         </div>

//         {/* Members Section */}
//         <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
//           <h3 className="text-xl font-semibold mb-4 flex items-center gap-2 text-cyan-700">
//             <Group className="!text-2xl" /> Team Members
//           </h3>
//           {team.members?.length ? (
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//               {team.members.map((member, index) => (
//                 <div key={index} className="bg-gray-50 p-3 rounded-lg flex items-center gap-3">
//                   <Person className="text-gray-500" />
//                   <div>
//                     <p className="font-medium">{member.name}</p>
//                     <p className="text-sm text-gray-600">{member.email}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="text-center p-4 bg-gray-100 rounded-lg text-gray-500">
//               No members registered yet
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MyTeamDetails;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { IoSettingsOutline } from "react-icons/io5";

import {
  Group,
  Person,
  Engineering,
  SmartToy,
  Email,
  Phone,
  CorporateFare,
  EmojiEvents,
  Badge,
  Image,
  Event,
} from "@mui/icons-material";
import { Link } from "react-router-dom";

const MyTeamDetails = () => {
  const { id } = useParams();
  const [team, setTeam] = useState(null);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("access_token");

  useEffect(() => {
    if (!token) {
      setError("You are not authorized. Please log in.");
      return;
    }

    const fetchTeamDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/team/user/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        if (!response.data) {
          throw new Error("No team data received");
        }
        setTeam(response.data);
      } catch (err) {
        setError(
          err.message || "Failed to fetch team details. Please try again.",
        );
      }
    };

    fetchTeamDetails();
  }, [id, token]);

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          {error}
        </Alert>
      </div>
    );
  }

  if (!team) {
    return (
      <div className="flex justify-center items-center h-screen text-xl font-semibold">
        Loading...
      </div>
    );
  }

  const competitionEvents = Array.isArray(team.competition_event)
    ? team.competition_event
    : team.competition_event
      ? [team.competition_event]
      : [];

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-xl rounded-2xl mt-10 mb-10 transition-all hover:shadow-2xl">
      {/* Header Section */}
      <div className="bg-gradient-to-r from-cyan-600 to-blue-500 text-white p-8 rounded-2xl text-center shadow-md relative">
        {/* Team Image */}
        {team.image && (
          <div className="absolute -top-8 left-8 w-16 h-16 rounded-full border-4 border-white overflow-hidden shadow-lg">
            <img
              src={team.image}
              alt={`${team.name} logo`}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/150";
              }}
            />
          </div>
        )}

        {/* Team Number Badge */}
        <div className="absolute -top-4 right-8 bg-yellow-400 text-gray-800 px-3 py-1 rounded-full text-sm font-bold shadow-md flex items-center gap-1">
          <Badge className="!text-sm" />
          <span>{team.team_number || "TBD"}</span>
          <Link to={`/Dashboard/TeamSetting/${team.id}`}>
            <IoSettingsOutline />
          </Link>
        </div>

        <h2 className="text-4xl font-bold mb-2 drop-shadow-md">{team.name}</h2>
        <div className="flex items-center justify-center gap-2">
          <EmojiEvents className="text-yellow-300" />
          <p className="text-xl font-medium">
            {team.competition_event
              ? typeof team.competition_event === "object"
                ? team.competition_event.name
                : team.competition_event
              : "No event specified"}
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="space-y-6 mt-8">
        {/* Key Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="bg-white p-4 rounded-xl border border-gray-200 flex items-center gap-4 hover:bg-gray-50 transition-colors">
            <div className="bg-cyan-100 p-3 rounded-lg text-cyan-600">
              <SmartToy className="!text-2xl" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Robot Name</p>
              <p className="font-medium text-gray-800">
                {team.robot_name || "TBA"}
              </p>
            </div>
          </div>

          <div className="bg-white p-4 rounded-xl border border-gray-200 flex items-center gap-4 hover:bg-gray-50 transition-colors">
            <div className="bg-cyan-100 p-3 rounded-lg text-cyan-600">
              <CorporateFare className="!text-2xl" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Organization</p>
              <p className="font-medium text-gray-800">
                {team.organization?.name
                  ? `${team.organization.name} (${team.organization.type})`
                  : "N/A"}
              </p>
            </div>
          </div>

          <div className="bg-white p-4 rounded-xl border border-gray-200 flex items-center gap-4 hover:bg-gray-50 transition-colors">
            <div className="bg-cyan-100 p-3 rounded-lg text-cyan-600">
              <Engineering className="!text-2xl" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Team Type</p>
              <p className="font-medium text-gray-800">{team.type || "N/A"}</p>
            </div>
          </div>
        </div>

        {competitionEvents.length > 0 && (
          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
            <h3 className="text-xl font-semibold mb-4 flex items-center gap-2 text-cyan-700">
              <Event className="!text-2xl" /> Competition Events
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {competitionEvents.map((event, index) => (
                <div
                  key={index}
                  className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm"
                >
                  <div className="flex justify-between items-start mb-2">
                    <h4 className="font-bold text-lg text-gray-800">
                      {event.name}
                    </h4>
                    <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded">
                      {event.competition}
                    </span>
                  </div>

                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <span className="font-medium">Location:</span>
                      <span>{event.location || "Not specified"}</span>
                    </div>

                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <span className="font-medium">Date:</span>
                      <span>{event.start_date}</span>
                    </div>

                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <span className="font-medium">Status:</span>
                      <span
                        className={`font-semibold ${event.is_live ? "text-green-600" : "text-gray-500"}`}
                      >
                        {event.is_live ? "Live Now" : "Completed"}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Team Image Section (if available) */}
        {team.image && (
          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
            <h3 className="text-xl font-semibold mb-4 flex items-center gap-2 text-cyan-700">
              <Image className="!text-2xl" /> Team Image
            </h3>
            <div className="flex justify-center">
              <img
                src={team.image}
                alt={`${team.name} team`}
                className="max-h-64 rounded-lg shadow-md"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://via.placeholder.com/500x300";
                }}
              />
            </div>
          </div>
        )}

        {/* Team Leader Card */}
        <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
          <h3 className="text-xl font-semibold mb-4 flex items-center gap-2 text-cyan-700">
            <Person className="!text-2xl" /> Team Leader
          </h3>
          <div className="space-y-3 pl-8">
            <div className="flex items-center gap-3 text-gray-700">
              <span className="text-gray-500">
                <Person />
              </span>
              <span>{team.team_leader_name || "Not provided"}</span>
            </div>
            <div className="flex items-center gap-3 text-gray-700">
              <span className="text-gray-500">
                <Email />
              </span>
              <span>{team.team_leader_email || "Not provided"}</span>
            </div>
            <div className="flex items-center gap-3 text-gray-700">
              <span className="text-gray-500">
                <Phone />
              </span>
              <span>{team.team_leader_phone_number || "Not provided"}</span>
            </div>
          </div>
        </div>

        {/* Members Section */}
        <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
          <h3 className="text-xl font-semibold mb-4 flex items-center gap-2 text-cyan-700">
            <Group className="!text-2xl" /> Team Members
          </h3>
          {team.members?.length ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {team.members.map((member, index) => (
                <div
                  key={index}
                  className="bg-gray-50 p-3 rounded-lg flex items-center gap-3"
                >
                  <Person className="text-gray-500" />
                  <div>
                    <p className="font-medium">{member.name}</p>
                    <p className="text-sm text-gray-600">{member.email}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center p-4 bg-gray-100 rounded-lg text-gray-500">
              No members registered yet
            </div>
          )}
        </div>

        {/* Coaches Section (if available) */}
        {team.coach?.length > 0 && (
          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
            <h3 className="text-xl font-semibold mb-4 flex items-center gap-2 text-cyan-700">
              <Person className="!text-2xl" /> Coaches
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {team.coach.map((coach, index) => (
                <div
                  key={index}
                  className="bg-gray-50 p-3 rounded-lg flex items-center gap-3"
                >
                  <Person className="text-gray-500" />
                  <div>
                    <p className="font-medium">{coach.name}</p>
                    <p className="text-sm text-gray-600">{coach.email}</p>
                    {coach.phone_competition_event && (
                      <p className="text-xs text-gray-500">
                        {coach.phone_competition_event}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyTeamDetails;
